import { render, staticRenderFns } from "./WatchlistButton.vue?vue&type=template&id=deeacdb0&scoped=true"
import script from "./WatchlistButton.vue?vue&type=script&lang=js"
export * from "./WatchlistButton.vue?vue&type=script&lang=js"
import style0 from "./WatchlistButton.vue?vue&type=style&index=0&id=deeacdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deeacdb0",
  null
  
)

export default component.exports